import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { getAdminFeatureToggle, updateAdminFeatureToggle } from '../../../../actions/feature-toggles';
import { destandard } from '../../../../utils/commonFunctions';
import PageTitle from '../../../common/page-title';
import FeatureToggleForm from './feature-toggle-form';

const model = 'deep.admin_feature_toggle_save';

class FeatureToggleFormPage extends Component {
  constructor(props) {
    super(props);

    const { match } = this.props;

    this.id = match.params.id;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAdminFeatureToggle(this.id)).then(() => {
      const { featureToggle } = this.props;
      const data = destandard({
        ...featureToggle.attributes
      });

      dispatch(actions.load(model, data));
    });
  }

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, updateAdminFeatureToggle(this.id, payload)));
  }

  renderForm = () => {
    const { isLoading } = this.props;

    return isLoading ? 'Loading...' : <FeatureToggleForm model={model} onSubmit={this.handleSubmit} />;
  }

  renderErrorMessage = () => {
    const { errors } = this.props;

    if (errors) {
      if (errors.message) {
        return errors.message;
      } else if (errors.error) {
        return errors.error;
      }
    }

    return this.renderForm();
  }

  render() {
    return (
      <div className="container-fluid">
        <PageTitle>Feature Toggle</PageTitle>
        {this.renderErrorMessage()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: !state.featureToggles.fetched && state.featureToggles.fetching,
  featureToggle: state.featureToggles.featureToggle,
  errors: state.featureToggles.errors
});

export default connect(mapStateToProps)(FeatureToggleFormPage);
